import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen relative overflow-hidden" }
const _hoisted_2 = { class: "relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8" }
const _hoisted_3 = { class: "w-full max-w-3xl" }
const _hoisted_4 = { class: "text-center mb-8" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "mb-6 rounded-md bg-green-50 p-4"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm text-green-700" }
const _hoisted_10 = {
  key: 1,
  class: "mb-6 rounded-md bg-red-50 p-4"
}
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "ml-3" }
const _hoisted_13 = { class: "text-sm text-red-700" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = ["type"]
const _hoisted_16 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_17 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = ["type"]
const _hoisted_20 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_21 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_22 = ["disabled"]

import { ref } from 'vue'
import { useResetPassword } from '@/composables/auth/useResetPassword'

// Use main JM Far East logo (generic for all brands)
// eslint-disable-next-line @typescript-eslint/no-var-requires

export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

const mainLogo = require('@/assets/main_logo.png')

// eslint-disable-next-line @typescript-eslint/no-var-requires
const backgroundImage = require('@/assets/staticbg.png')

// Password visibility state
const showPassword = ref(false)
const showConfirmPassword = ref(false)

const { password, confirmPassword, loading, error, success, handleResetPassword } = useResetPassword()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute inset-0 bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: `url(${_unref(backgroundImage)})` })
    }, null, 4),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-70" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(mainLogo),
              alt: "JM Far East",
              class: "mx-auto w-96 object-contain mb-6"
            }, null, 8, _hoisted_5),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-6 mb-4 text-2xl text-white" }, " Enter your new password below ", -1))
          ]),
          (_unref(success))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-green-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(success)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(error))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-red-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(error)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleResetPassword) && _unref(handleResetPassword)(...args)), ["prevent"])),
            class: "space-y-6"
          }, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                type: showPassword.value ? 'text' : 'password',
                placeholder: "New Password*",
                required: "",
                class: "w-full px-8 py-5 pr-14 bg-transparent border-2 border-white rounded-lg focus:outline-none focus:border-blue-400 placeholder-white placeholder:text-lg text-white transition-colors"
              }, null, 8, _hoisted_15), [
                [_vModelDynamic, _unref(password)]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value)),
                class: "absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-blue-400 transition-colors"
              }, [
                (showPassword.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[8] || (_cache[8] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                      }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[9] || (_cache[9] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                      }, null, -1),
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      }, null, -1)
                    ])))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                id: "confirmPassword",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(confirmPassword) ? (confirmPassword).value = $event : null)),
                type: showConfirmPassword.value ? 'text' : 'password',
                placeholder: "Confirm Password*",
                required: "",
                class: "w-full px-8 py-5 pr-14 bg-transparent border-2 border-white rounded-lg focus:outline-none focus:border-blue-400 placeholder-white placeholder:text-lg text-white transition-colors"
              }, null, 8, _hoisted_19), [
                [_vModelDynamic, _unref(confirmPassword)]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                class: "absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-blue-400 transition-colors"
              }, [
                (showConfirmPassword.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _cache[10] || (_cache[10] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                      }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_21, _cache[11] || (_cache[11] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                      }, null, -1),
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      }, null, -1)
                    ])))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _unref(loading),
                class: "w-full py-5 px-4 rounded-lg text-xl font-medium transition-all duration-200 bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              }, _toDisplayString(_unref(loading) ? 'Resetting...' : 'Reset Password'), 9, _hoisted_22)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})